<ion-accordion-group *ngIf="patients.length" value="first">
  <ion-accordion toggleIconSlot="start" value="first">
    <ion-item slot="header" color="light">
      <ion-label>
        <strong translate>Mobile.Patient</strong>
      </ion-label>
    </ion-item>
    <div slot="content">
      <app-callcard-cpatient-card *ngFor="let patient of patients" [patient]="patient"></app-callcard-cpatient-card>
    </div>
  </ion-accordion>
</ion-accordion-group>
